import { FetchHelper } from "shared-ts-utils-fetch";

export class McUserDao {
  private readonly fetchHelper: FetchHelper;

  constructor() {
    this.fetchHelper = new FetchHelper({
      basePath: "/api/user/",
    });
  }
  delete(): Promise<void> {
    return this.fetchHelper.delete("delete").fetch();
  }
}
